// src/services/stake.service.ts
import { createApiClient } from "@/utils/api";
import type {
  CreateDepositRequest,
  Deposit,
  DepositResponse,
  ListDepositsRequest,
  ListDepositsResponse,
} from "@/gen/api/v1/api_pb";
import { IDRequestSchema } from "@/gen/api/v1/common_pb";
import { DepositService } from "@/gen/api/v1/api_pb";

const client = createApiClient(DepositService);

export const depositService = {
  listDeposits: (
    request: ListDepositsRequest,
  ): Promise<ListDepositsResponse> => {
    return client.listDeposits(request);
  },

  createDeposit: (request: CreateDepositRequest): Promise<DepositResponse> => {
    return client.createDeposit(request);
  },
};

export type {
  ListDepositsRequest,
  ListDepositsResponse,
  CreateDepositRequest,
  Deposit,
  IDRequestSchema,
};
